import { Alert } from '@tempmee/react';
import history from '~/browserHistory';
import { routes } from '~/routes';
import { toViewedOfficePath } from '~/utils/viewedOfficeScope';
import { usePendingAchBannerVisible } from './usePendingAchBannerVisible';

interface IPendingAchVerificationBannerProps {
  containerStyle?: React.CSSProperties;
  dataCy?: string;
  /** The location whose bank accounts are checked, and whose Billing Details it opens. */
  officeId?: string;
}

export const PendingAchVerificationBanner = ({
  containerStyle,
  dataCy = 'pending-ach-warning',
  officeId,
}: IPendingAchVerificationBannerProps) => {
  const isVisible = usePendingAchBannerVisible(officeId);

  if (!isVisible) {
    return null;
  }

  const billingPath = officeId
    ? toViewedOfficePath(routes.paymentInformation, { kind: 'location', officeId })
    : routes.paymentInformation;

  return (
    <Alert
      data-cy={dataCy}
      severity="warning"
      role="button"
      tabIndex={0}
      onClick={() => history.push(billingPath)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          history.push(billingPath);
        }
      }}
      style={{
        cursor: 'pointer',
        marginBottom: 0,
        ...containerStyle,
      }}
      description="Bank Account Pending. Confirm deposit now"
    />
  );
};
